import React from "react";
import { useContext } from "react";
import { Switch, Redirect } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import ProtectedLogin from "./ProtectedLogin";
import AuthApi from "./AuthApi";

import Header from "../components/Header";
import Footer from "../components/Footer";
import Menu from "../components/Menu";
import Content from "../components/Content";
import Login from "../components/Login";
import LockScreen from "../components/LockScreen";
import Home from "../components/Home";
import Page404 from "../components/Page404";

import Employee from "../components/Employee";

import WrappedApp from "../components/BasicForm";

function Routes() {
  const Auth = useContext(AuthApi);
  console.log("Auth Routes: ", Auth.auth);
  return (
    <Switch>
      {/* <ProtectedRoute
        exact
        path="/dashboard3"
        auth={Auth.auth}
        component={Dashboard3}
      ></ProtectedRoute> */}

      <ProtectedRoute exact path="/basic" auth={Auth.auth}>
        <div className="wrapper">
          <Header></Header>
          <Menu></Menu>
          <WrappedApp />
          <Footer></Footer>
        </div>
      </ProtectedRoute>

      <ProtectedLogin
        exact
        path="/LockScreen"
        auth={Auth.auth}
        component={LockScreen}
      />

      <ProtectedLogin exact path="/login" auth={Auth.auth} component={Login} />

      <ProtectedRoute exact path="/employee" auth={Auth.auth}>
        <div className="wrapper">
          <Header></Header>
          <Menu></Menu>
          <Employee />
          <Footer></Footer>
        </div>
      </ProtectedRoute>

      {/* Home Page */}
      {/* <ProtectedRoute exact path="/home" auth={Auth.auth} component={RHome} /> */}
      <ProtectedRoute exact path="/home" auth={Auth.auth}>
        <div className="wrapper">
          <Header></Header>
          <Menu></Menu>
          <Home />
          <Footer></Footer>
        </div>
      </ProtectedRoute>

      {/* Home Page */}
      <ProtectedRoute
        exact
        path="/"
        auth={Auth.auth}
        component={Home}
      ></ProtectedRoute>

      <ProtectedRoute exact path="/employee" auth={Auth.auth}>
        <div className="wrapper">
          <Header></Header>
          <Menu></Menu>
          <Employee />
          <Footer></Footer>
        </div>
      </ProtectedRoute>

      <ProtectedLogin path="*" component={Page404} />
    </Switch>
  );
}

export default Routes;

const RHome = () => {
  return (
    <div className="wrapper">
      <Header></Header>
      <Menu></Menu>
      <Home />
      <Footer></Footer>
    </div>
  );
};

const RDashboard3 = () => {
  return (
    <div className="wrapper">
      <Header></Header>
      <Menu></Menu>
      <Content />
      <Footer></Footer>
    </div>
  );
};

const RLogin = () => {
  return (
    <div className="wrapper">
      Login
      <Redirect to="/home" />
    </div>
  );
};
